export const PLACEHOLDER_IMAGE_URN = "/uploads/media_library/3759b3df5982ce78756f289321cb79d3.png";
